import { typographyDesktop } from '@shared/tokens/typography.desktop.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { InputSizes } from '../model/types';
import * as stylex from '@stylexjs/stylex';

type TSizes = {
  small: string;
  medium: string;
  large: string;
};

const sizes: TSizes = {
  small: typography['fontSizeCaption-1'],
  medium: typography['fontSizeBody-3'],
  large: typography['fontSizeBody-2'],
};

export const styles = stylex.create({
  container: {
    position: 'relative',
  },
  containerDisabled: {
    cursor: 'not-allowed',
  },
  base: {
    border: '1px solid',
    borderRadius: anatomy['size-8'],
    ':focus': {
      outline: 'none',
    },
    background: colors.primaryBackground,
    color: colors.primaryText,
    width: '100%',
  },
  isDisabled: {
    borderColor: colors.ghostBorder,
    background: colors.ghostBackground,
    '::placeholder': {
      color: colors.ghostText,
    },
    color: colors.ghostText,
    cursor: 'not-allowed',
    ':hover': {
      borderColor: 'none',
    },
  },
  isReadonly: {
    background: colors.ghostBackground,
    color: colors.foregroundTertiary,
    userSelect: 'none',
    ':hover': {
      borderColor: colors.tertiaryBorder,
    },
    ':focus': {
      borderColor: colors.tertiaryBorder,
    },
  },
  inputText: (size: InputSizes) => ({
    fontFamily: fonts.din2014Regular,
    lineHeight:
      size === 'large'
        ? typographyDesktop['lineHeightBody-2']
        : size === 'medium'
          ? typographyDesktop['lineHeightBody-4']
          : typographyDesktop['lineHeightCaption-1'],
    fontWeight: typographyDesktop.fontWeighRegular,
    fontSize: sizes[size],
    paddingLeft: size === 'small' ? '16px' : '20px',
  }),
  inputMsgSize: (size) => ({
    fontFamily: fonts.din2014Regular,
    paddingTop: '3px',
    lineHeight:
      size === 'large'
        ? typographyDesktop['lineHeightCaption-1']
        : size === 'medium'
          ? typographyDesktop['lineHeightCaption-2']
          : '12px',
    fontSize:
      size === 'large'
        ? typographyDesktop['fontSizeCaption-1']
        : size === 'medium'
          ? typographyDesktop['fontSizeCaption-2']
          : '10px',
  }),
  labelText: (size) => ({
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    fontFamily: fonts.din2014Regular,
    color: colors.secondaryText,
    height: size === 'large' ? '28px' : size === 'medium' ? '20px' : '',
    top: size === 'large' ? '-32px' : size === 'medium' ? '-23px' : '-20px',
    lineHeight:
      size === 'large'
        ? typographyDesktop['fontSizeHeading-4']
        : size === 'medium'
          ? typographyDesktop['lineHeightCaption-1']
          : typographyDesktop['lineHeightCaption-2'],
    fontSize:
      size === 'large'
        ? typographyDesktop['fontSizeBody-4']
        : size === 'medium'
          ? typographyDesktop['fontSizeCaption-1']
          : '12px',
  }),
  inputMsgColor: (status) => ({
    color: status === 'success' ? colors.successText : colors.errorText,
  }),
  searchIcons: (size) => ({
    position: 'absolute',
    display: 'flex',
    gap: '8px',
    top: size === 'large' ? '18px' : size === 'medium' ? '14px' : '10px',
    right: size === 'large' ? '18px' : size === 'medium' ? '20px' : '16px',
  }),

  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'absolute',
  },
  eyeIcon: (size) => ({
    position: 'absolute',
    cursor: 'pointer',
    color: colors.primaryIcon,
    top: size === 'large' ? '16px' : size === 'medium' ? '12px' : '10px',
    right: size === 'large' ? '20px' : size === 'medium' ? '20px' : '16px',
  }),
  size: {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
  },
  small: {
    width: '280px',
    height: anatomy['size-36'],
  },
  medium: {
    width: '280px',
    height: anatomy['size-48'],
  },
  large: {
    width: '280px',
    height: '60px',
  },
  success: {
    borderColor: colors.successBorder,
  },
  error: {
    borderColor: colors.errorBorder,
  },
  default: {
    borderColor: colors.tertiaryBorder,
    ':hover': {
      borderColor: colors.hoverBorder,
    },
    ':focus': {
      borderColor: colors.accentBorder,
    },
  },
  XMarksIcon: {
    cursor: 'pointer',
  },
});
